"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Drawer = exports.useDrawerContext = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var Close_1 = __importDefault(require("@material-ui/icons/Close"));
var logo_white_svg_1 = __importDefault(require("../../assets/images/logo-white.svg"));
var logo_blue_svg_1 = __importDefault(require("../../assets/images/logo-blue.svg"));
var drawer_rocket_png_1 = __importDefault(require("../../assets/images/drawer-rocket.png"));
var DrawerContext = react_1.default.createContext(undefined);
exports.useDrawerContext = function () {
    var closeDrawer = react_1.default.useContext(DrawerContext);
    if (closeDrawer === undefined)
        throw new Error("useDrawerContext must be used within a DrawerContext provider");
    return closeDrawer;
};
exports.Drawer = function (props) {
    var classes = useStyles(props);
    return (react_1.default.createElement(core_1.SwipeableDrawer, __assign({ anchor: "right" }, props, { className: clsx_1.default(classes.showXsDown, classes.drawer) }),
        react_1.default.createElement(core_1.Grid, { container: true, direction: "column" },
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(core_1.Toolbar, { className: classes.topBar },
                    react_1.default.createElement(core_1.Grid, { container: true, spacing: 4, wrap: "nowrap" },
                        react_1.default.createElement(core_1.Grid, { item: true, className: classes.logo },
                            react_1.default.createElement(core_1.Link, { href: props.logoLink || "/" },
                                react_1.default.createElement("img", { src: props.primary ? logo_white_svg_1.default : logo_blue_svg_1.default, alt: "SwagUp logo" }))),
                        react_1.default.createElement(core_1.Grid, { item: true, style: { marginLeft: "auto" } },
                            react_1.default.createElement(core_1.IconButton, { className: classes.closeButton },
                                react_1.default.createElement(Close_1.default, { onClick: props.onClose })))))),
            react_1.default.createElement(core_1.Grid, { item: true, className: classes.content },
                react_1.default.createElement(DrawerContext.Provider, { value: function () { return props.onClose(null); } }, props.children)))));
};
var useStyles = styles_1.makeStyles(function (_a) {
    var _b, _c, _d, _e;
    var breakpoints = _a.breakpoints, palette = _a.palette;
    return ({
        drawer: function (props) {
            return props.primary
                ? {
                    "& > .MuiDrawer-paper": {
                        backgroundColor: palette.primary.main,
                        backgroundImage: "url(" + drawer_rocket_png_1.default + ")",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "right bottom",
                    },
                }
                : {};
        },
        topBar: (_b = {
                minHeight: 64,
                paddingLeft: 12,
                paddingRight: 12
            },
            _b[breakpoints.down("xs")] = {
                paddingLeft: 24,
            },
            _b),
        content: {
            padding: 24,
        },
        logo: {
            "& > a": (_c = {
                    height: "100%",
                    display: "flex",
                    "& > img": {
                        width: 168,
                    }
                },
                _c[breakpoints.down("sm")] = {
                    "& > img": {
                        width: 128,
                    },
                },
                _c),
        },
        closeButton: {
            color: function (props) {
                return props.primary ? palette.common.white : palette.common.black;
            },
        },
        showXsDown: (_d = {
                display: "none"
            },
            _d[breakpoints.down("xs")] = {
                display: "inherit",
            },
            _d),
        hideXsDown: (_e = {},
            _e[breakpoints.down("xs")] = {
                display: "none",
            },
            _e),
    });
});
